import './icons.scss'
export default function HomeMinimalistComponent({
  width = '44px',
  height = '50px',
  color = 'lightgray',
  className = ''
}: {
  width?: string
  height?: string
  color?: string
  className?: string
}) {
  return (
    <div
      className={'clip ' + className}
      style={{
        clipPath: 'polygon(50% 0, 0% 40%, 4% 40%, 5% 100%, 95% 100%, 96% 40%, 100% 40%)',
        width,
        height,
        background: color,
        position: 'relative'
      }}></div>
  )
}
